import { UserContext } from "context/User/UserContext";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import api from "utils/axiosInstance";

export default function HRVBHandouts(props) {
  const [revealedLinks, setRevealedLinks] = useState(Array(6).fill(false));
  const [currentWeek, setCurrentWeek] = useState(2);
  const [error, setError] = useState({ state: false, message: "" });
  const { user } = useContext(UserContext);

  const handleCardClick = (index) => {
    const newRevealedLinks = [...revealedLinks];
    newRevealedLinks[index] = true;
    setRevealedLinks(newRevealedLinks);
  };

  useEffect(() => {
    (async function () {
      const username = user.username;
      if (username) {
        const currWeekumber = await getCurrentWeekNumber(username);
        setCurrentWeek(currWeekumber);
      }
    })();
  }, []);

  async function getCurrentWeekNumber(subjectId) {
    try {
      const weekNumberRes = await api({
        method: "get",
        url: `/${subjectId}/week`,
      });
      return weekNumberRes.data;
    } catch (err) {
      if (err.response && err.response.data)
        setError({
          state: true,
          message:
            (err.response && err.response.data.message) ||
            "An Unknown error occured",
        });
    }
  }

  const cardData = [
    {
      title: "Week 1",
      links: {
        // "Wear and Care of the LEAP Device":
        //   "/dashboard/artifacts/handouts/hrvb/An HRVB Primer.pdf",
        // "How to use the Inner Balance Device":
        //   "/dashboard/artifacts/handouts/hrvb/How to use the Inner balance device.pdf",
        // "Optimal HRV: Having Trouble Connecting to your Device":
        //   "/dashboard/artifacts/handouts/hrvb/Optimal HRV_ Having Trouble Connecting to Your Device.pdf",
        // "How to use the Optimal HRV App":
        //   "/dashboard/artifacts/handouts/hrvb/How to use the Optimal HRV App.pdf",
        "An HRVB Primer":
          "/dashboard/artifacts/handouts/hrvb/An HRVB Primer.pdf",
        "How HRV Helps you take control of your health":
          "/dashboard/artifacts/handouts/hrvb/How HRV Helps You Take Control of Your Health.pdf",
      },
    },
    {
      title: "Week 2",
      links: {
        "HRVB RF Breathing Instructions":
          "/dashboard/artifacts/handouts/hrvb/HRVB RF Breathing Instructions.pdf",
      },
    },
    {
      title: "Week 3",
      links: {
        "Physical Activity and HRV":
          "/dashboard/artifacts/handouts/hrvb/Physical Activity and HRV.pdf",
      },
    },
    {
      title: "Week 4",
      links: {
        "Stress and Emotional Awareness Toolkit":
          "/dashboard/artifacts/handouts/hrvb/Stress and Emotional Awareness Toolkit.pdf",
      },
    },
  ];

  return (
    <Container className="mt-4">
      <Row className="mb-4">
        <Col>
          <Card className="h-100 shadow-sm">
            <Card.Body className="text-center">
              <Card.Title>Videos</Card.Title>
              <div>
                <a
                  href="https://youtu.be/MvqE2lUMJcM?si=S8jjeIQl9b2xpHwv"
                  target="_blank"
                  rel="noreferrer"
                >
                  What is Heart Rate Variability Biofeedback (Dr. Gharbo)
                </a>
              </div>

              <div>
                <a
                  href="https://youtu.be/TMeDpU9yqrY?si=zrEQM-O2d0KrngMz"
                  target="_blank"
                  rel="noreferrer"
                >
                  HRV is Good! (Dr. Ginsberg)
                </a>
              </div>

              <div>
                <a
                  href="https://youtu.be/eAJERpidKOU?si=1C9h9rfPSe4kJXI3"
                  target="_blank"
                  rel="noreferrer"
                >
                  Autonomic Self-Regulation (Dr. Ginsberg)
                </a>
              </div>

              <div>
                <a
                  href="https://youtu.be/KYUJIYcioQQ?si=sVFesiGsh9-ASY48"
                  target="_blank"
                  rel="noreferrer"
                >
                  Why is HRV Important? (Optimal HRV)
                </a>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="h-100 shadow-sm">
            <Card.Body className="text-center">
              <Card.Title>Handouts</Card.Title>
              <div>
                <a
                  href="/dashboard/artifacts/handouts/hrvb/An HRVB Primer.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  Wear and Care of the LEAP Device
                </a>
              </div>

              <div>
                <a
                  href="/dashboard/artifacts/handouts/hrvb/How to use the Inner balance device.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  How to use the Inner Balance Device
                </a>
              </div>

              <div>
                <a
                  href="/dashboard/artifacts/handouts/hrvb/Optimal HRV_ Having Trouble Connecting to Your Device.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  Optimal HRV: Having Trouble Connecting to your Device
                </a>
              </div>

              <div>
                <a
                  href="/dashboard/artifacts/handouts/hrvb/How to use the Optimal HRV App.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  How to use the Optimal HRV App
                </a>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="h-100 shadow-sm">
            <Card.Body className="text-center">
              <Card.Title>Website</Card.Title>
              <a
                href="https://my.clevelandclinic.org/health/symptoms/21773-heart-rate-variability-hrv"
                target="_blank"
                rel="noreferrer"
              >
                HRV: What it is
              </a>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="justify-content-center">
        {cardData.map((card, index) => (
          <Col>
            <Card
              onClick={() => handleCardClick(index)}
              className="text-center d-flex justify-content-center mb-3"
            >
              <Card.Title>{card.title}</Card.Title>
              {currentWeek > index ? (
                <Card.Body>
                  {Object.entries(cardData[index]["links"]).map(
                    ([key, value]) => (
                      <div key={key} className="mt-3">
                        <a href={`${value}`} target="_blank" rel="noreferrer">
                          {`${key}`}
                        </a>
                      </div>
                    ),
                  )}
                </Card.Body>
              ) : (
                <Card.Body>This content is locked</Card.Body>
              )}
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
